
import { request } from '@umijs/max';
import type {LoginParams,CurrentUser, ModifyPwdParams,buildJobSheet,Banzu,job,HeDao,WorkAddress,ModifyPwdAfterLoginParams ,AccessMenus,LoginResult,UserDetailList } from '@shenpu/shared-types'; 
import { result, UserDetail } from "@shenpu/shared-types";
/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: CurrentUser;
  }>('/api/currentUser', {
    method: 'GET',
    ...(options ||{}),
  });
}

export async function getcaptcha(options?: { [key: string]: any }){
  return request<Record<string,string>>('/api/getcaptcha',{
    method: 'GET',
    ...(options || {}),
  })
}





/**登录修改密码接口 post /modifypwdafterlogin*/
export async function modifypwdafterlogin(body:ModifyPwdAfterLoginParams,options?:{[key:string]:any}){
  return request<Record<string,any>>('/api/modifypwdafterlogin',{
    method: 'POST',
    data: body||{}
  });
}

/**修改密码接口 post /modifypwd */
export async function modifypwd(body:ModifyPwdParams,options?:{[key:string]:any}){
  return request<any>('/api/modifypwd',{
  method: 'POST',
  data: body || {},
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: LoginParams, options?: { [key: string]: any }) {
  const response = await request<LoginResult>('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),

  });

  if (response.userkey) {
    localStorage.setItem('userkey', response.userkey);
  }

  return response;
}

export async function loginas(body:LoginParams,options?:{[key:string]:any}){
  const response = await request<LoginResult>('/api/loginas', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),

  });

  if (response.userkey) {
    localStorage.setItem('userkey', response.userkey);
  }

  return response;
}